import { render } from "./OtiClock.vue?vue&type=template&id=ebd33cb8&scoped=true"
import script from "./OtiClock.vue?vue&type=script&lang=js"
export * from "./OtiClock.vue?vue&type=script&lang=js"

import "./OtiClock.vue?vue&type=style&index=0&id=ebd33cb8&lang=scss&scoped=true"

import exportComponent from "D:\\OSOLE\\metalpro\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd33cb8"]])

export default __exports__